// extracted by mini-css-extract-plugin
export default {"ascending":"selectionTable__ascending__vYuq2","descending":"selectionTable__descending__bm9Q1"};